import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export const axiosInstance: AxiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const url = config.url || '';
    if (!url.includes('/api') && !url.includes('/auth')) {
      config.withCredentials = false;
    }
    return config;
  }
);

export default axiosInstance;
